import { appUrl, playStoreUrl } from "@/services/api";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export const AppLink = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const schemeUrl = `${appUrl}${searchParams.get("url")}`;
    const fallbackUrl = playStoreUrl;

    // Try to open the app
    window.location.href = schemeUrl;

    // Set timeout to redirect to Play Store if app is not installed
    const timeout = setTimeout(() => {
      window.location.href = fallbackUrl;
    }, 2000); // 2 seconds is usually safe

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div>
      <h2>Opening AasPassHub...</h2>
      <p>
        If nothing happens, <a href={playStoreUrl}>click here</a> to install the
        app.
      </p>
    </div>
  );
};
